<template>
  <div>
    <template v-if="isMobile()">
      <content-loader
        clas="loader"
        :speed="3"
        primaryColor="#f3f3f3"
        secondaryColor="#ddd"
        preserveAspectRatio
        :height="900"
        :width="540"
      >
        <rect x="0" y="0" rx="0" ry="0" width="75" height="45" />
        <rect x="85" y="0" rx="0" ry="0" width="130" height="8" />
        <rect x="85" y="15" rx="0" ry="0" width="130" height="8" />
        <rect x="85" y="30" rx="0" ry="0" width="130" height="8" />
        <rect x="85" y="45" rx="0" ry="0" width="125" height="22" />
        <!-- <rect x="155" y="52" rx="0" ry="0" width="60" height="22" /> -->

        <rect x="0" y="90" rx="0" ry="0" width="75" height="45" />
        <rect x="85" y="90" rx="0" ry="0" width="130" height="8" />
        <rect x="85" y="105" rx="0" ry="0" width="130" height="8" />
        <rect x="85" y="120" rx="0" ry="0" width="130" height="8" />
        <rect x="85" y="135" rx="0" ry="0" width="125" height="22" />
        <!-- <rect x="155" y="142" rx="0" ry="0" width="60" height="22" /> -->

        <rect x="0" y="180" rx="0" ry="0" width="75" height="45" />
        <rect x="85" y="180" rx="0" ry="0" width="130" height="8" />
        <rect x="85" y="195" rx="0" ry="0" width="130" height="8" />
        <rect x="85" y="210" rx="0" ry="0" width="130" height="8" />
        <rect x="85" y="225" rx="0" ry="0" width="125" height="22" />
        <!-- <rect x="155" y="232" rx="0" ry="0" width="120" height="22" /> -->
      </content-loader>
    </template>

    <template v-else>
      <content-loader
        clas="loader"
        :speed="3"
        primaryColor="#f3f3f3"
        secondaryColor="#ddd"
        preserveAspectRatio
      >
        <rect class="first" x="0" y="0" rx="4" ry="4" width="120" height="85" />
        <rect class="first" x="0" y="93" rx="4" ry="4" width="120" height="5" />
        <rect
          class="first"
          x="0"
          y="103"
          rx="2"
          ry="2"
          width="120"
          height="5"
        />
        <rect
          class="first"
          x="0"
          y="113"
          rx="2"
          ry="2"
          width="120"
          height="5"
        />

        <rect x="130" y="0" rx="4" ry="4" width="120" height="85" />
        <rect x="130" y="93" rx="4" ry="4" width="120" height="5" />
        <rect x="130" y="103" rx="4" ry="4" width="120" height="5" />
        <rect x="130" y="113" rx="4" ry="4" width="120" height="5" />

        <rect x="260" y="0" rx="4" ry="4" width="120" height="85" />
        <rect x="260" y="93" rx="4" ry="4" width="120" height="5" />
        <rect x="260" y="103" rx="4" ry="4" width="120" height="5" />
        <rect x="260" y="113" rx="4" ry="4" width="120" height="5" />
      </content-loader>
    </template>
  </div>
</template>

<script>
import { ContentLoader } from "vue-content-loader";
import { mapState } from "vuex";

export default {
  components: {
    ContentLoader,
  },

  computed: {
    ...mapState(["nextLoaderMobile"]),
  },
};
</script>

<style scoped>
#shopbox div {
  width: 100%;
  height: 100%;
}
#shopbox svg {
  width: 100%;
  max-width: 100%;
  height: 100%;
  transform-origin: left center;
  transform: scaleY(1) scaleX(1.045);
}
@media (max-width: 640px) {
  #shopbox div {
    width: calc(100vw - 36px);
    overflow: hidden;
  }
  #shopbox svg {
    height: 90vh;
    transform: none !important;
  }
  #shopbox svg rect {
    transform: scaleX(1.6) scaleY(1.9);
  }
  #shopbox svg > rect {
    height: 100%;
  }
}
</style>
